import { COPILOT_DISCLAIMER } from "./roof-copilot.js";
const SEV_RANK = { critical: 3, warning: 2, info: 1 };
/**
 * Baut Copilot-Beratung aus einer geordneten Schritt-Liste. Die Reihenfolge der
 * `steps` ist die Planungsreihenfolge — der erste offene Schritt wird zum
 * „nächsten Schritt". Erledigte Schritte erzeugen keinen Hinweis.
 */
export function buildPlanningAdvice(steps, opts = {}) {
    const total = steps.length;
    const open = steps.filter((s) => !s.done);
    const doneCount = total - open.length;
    const hints = open
        .map((s) => ({
        code: s.key,
        severity: s.severity ?? "warning",
        title: s.label,
        detail: s.detail,
        nextStep: s.nextStep,
    }))
        .sort((a, b) => SEV_RANK[b.severity] - SEV_RANK[a.severity]);
    const readiness = hints.some((h) => h.severity === "critical")
        ? "not_ready"
        : hints.length > 0
            ? "caution"
            : "ready";
    // Nächster Schritt = erster offener Schritt in der übergebenen Reihenfolge.
    const firstOpen = open[0];
    const nextStep = firstOpen ? firstOpen.nextStep : null;
    const headline = readiness === "ready"
        ? opts.readyHeadline ?? `Alle ${total} Schritte erledigt — menschliche Prüfung weiterhin nötig.`
        : `${doneCount}/${total} Planungsschritte erledigt · ${open.length} offen.`;
    return {
        headline,
        readiness,
        hints,
        nextStep,
        disclaimer: COPILOT_DISCLAIMER,
        requiresHumanReview: true,
        canApprove: false,
    };
}
/**
 * Projektweite Planungs-Readiness (Dach → First/Traufe → Ertrag → Stringing →
 * Wirtschaft → Konzept). Deterministisch, reine Ableitung aus Status-Flags.
 */
export function buildProjectReadinessAdvice(input) {
    const steps = [
        { key: "roof_surface", label: "Dachfläche angelegt", done: input.roofSurfaceCount > 0, severity: "critical",
            detail: "Ohne Dachfläche keine Belegung, kein Ertrag, kein Konzept.", nextStep: "Im Dach-Editor eine Dachfläche zeichnen." },
        { key: "edges", label: "First/Traufe gesetzt", done: input.hasFirstTraufe,
            detail: "First/Traufe definieren Ausrichtung und Randabstände für die Belegung.", nextStep: "Im Dach-Editor First- und Trauflinie zeichnen." },
        { key: "yield", label: "PVGIS-Ertrag berechnet", done: input.yieldPresent,
            detail: "Ohne standortbezogenen Ertrag sind Wirtschaftlichkeit und Konzept nicht belastbar.", nextStep: "Simulation/PVGIS-Ertrag ausführen." },
        { key: "stringing", label: "Stringing/WR geprüft", done: input.stringingPresent,
            detail: "Strang-/MPPT-/WR-Prüfung stellt sicher, dass die Verschaltung im WR-Fenster liegt.", nextStep: "PV-Auslegung (Strang-Check) durchführen." },
        { key: "economics", label: "Wirtschaftlichkeit/Kalkulation", done: input.calcPresent,
            detail: "Kosten/Wirtschaftlichkeit sind Richtwerte/Entwurf bis zur Vor-Ort-Prüfung.", nextStep: "Wirtschaftlichkeit rechnen bzw. Kalkulation erstellen." },
        { key: "concept", label: "Konzept/Dokument (ENTWURF)", done: input.conceptPresent,
            detail: "Das Kundendokument bleibt ENTWURF — keine automatische Freigabe.", nextStep: "Konzept-Entwurf erzeugen (bleibt ENTWURF, menschlich prüfen)." },
    ];
    return buildPlanningAdvice(steps, {
        readyHeadline: "Alle Planungsschritte vorbereitet — Freigabe nur durch Menschen (ENTWURF).",
    });
}
//# sourceMappingURL=planning-copilot.js.map